import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import DraggableModuleContainer from '~components/generic/module/DraggableModuleContainer';
import { ModulesListPopover } from '~components/generic/module/ModulesListPopover/ModulesListPopover';
import { IEntityComponentProps } from '~interfaces/props';
import { getRelatedEntityIds } from '~services/entity-helpers';

export default function ModuleBgcontainer(props: IEntityComponentProps) {
  const { data, editing, onChange, className, origData, stable } = props;
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const childModuleIds = getRelatedEntityIds(data, 'field_modules');
  const childModuleIdsLength = childModuleIds.length - 1;

  const moduleClasses = clsx({ ...className.module }, content.field_css_color_class);
  const containerClasses = clsx({
    ...className.container,
    'px-0': true,
    relative: true,
  });

  return (
    <div className={moduleClasses} id={origData}>
      <div className={containerClasses}>
        <div className="o-grid o-grid--unpad o-grid--wrap c-module__header">
          <div className="o-grid__cell o-grid__cell--width-12">
            <EditableField
              hide={content.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={content.field_title.value}
              editing={editing}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="c-bgcontainer__content u-margin-bottom-lg u-margin-top-sm c-module__content">
          {editing && childModuleIdsLength === -1 ? (
            <div className="container relative">
              <ModulesListPopover type={data.type} parentContext={data.id} index={0} />
            </div>
          ) : (
            <>
              {childModuleIds.map((id, i) => {
                return (
                  <div key={i} className="">
                    {editing && (
                      <div className="container relative">
                        <ModulesListPopover type={data.type} parentContext={data.id} index={0} />
                      </div>
                    )}
                    <DraggableModuleContainer
                      parentIsStable={stable}
                      index={i}
                      key={id}
                      entityId={id}
                      parentContext={data.id}
                      parentType={data.type}
                      fieldName="relationships.field_modules.data"
                      siblingsLength={childModuleIdsLength}
                      canMove={editing}
                    />
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
